<template>
  <div id="Dashboard"  class="container is-fluid">
    <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet">

    <!-- Header -->
    <HeroContainer title="PO SO Dashboard" />

    <section id="filters" style="display:flex; justify-content:center;">
      <div style="width:500px" >
        
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Group by</label>
          </div>
          <div class="field-body">
            <div class="field">
              <span class="select">
                    <select id="period" 
                        v-model="period" >
                      <option disabled hidden value="" style="color:grey;">Period</option>
                      <option value='day'>Day</option>
                      <option value='week'>Week</option>
                      <option value='month'>Month</option>
                      <option value='quarter'>Quarter</option>
                    </select>
                  </span>
            </div>
          </div>
        </div>
        
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Period</label>
          </div>
          <div class="field-body">
            <div class="field has-addons" >
              <p class="control">
                <span class="select">
                  <select id="date_range" 
                    v-model="date_range" @change="change_date(date_range)">
                    <option disabled hidden value="" style="color:grey;">Date Presets</option>
                    <option value='today'>Today</option>
                    <option value='week'>Week</option>
                    <option value='this_month'>This Month</option>
                    <option value='prev_month'>Prev Month</option>
                    <option value='this_quarter'>This Quarter</option>
                    <option value='prev_quarter'>Prev Quarter</option>
                    <option value='this_year'>This Year</option>
                    <option value='prev_year'>Prev Year</option>
                    <option value='all'>All</option>
                    <option disabled hidden value='custom'>Custom</option>
                  </select>
                </span>
              </p>
              <p class="control  is-expanded">
                <VueDatePicker v-model="range" :enable-time-picker="false" range/>
              </p>
            </div>
          </div>
        </div>

        <div class="buttons is-right">
          <button @click='reset' class="button is-small is-white">Reset</button>
          <button @click='ajax_get_dashboard' class="button is-info">Filter</button>
        </div>
      </div>
    </section>

    <section id="plot_data">
      <PlotlyFigure
        :plot_data="plotData"
        :layout="layout"
        :options="options"
        v-on:plot_click='plot_click'
        :key="figureKey"
        >
      </PlotlyFigure>
    </section>

    <section id="dashboard_data_so" v-if="Object.prototype.hasOwnProperty.call(queryDataRaw, 'so')">
      <DataTable2 
        :raw_data="queryDataRaw.so"
        :name="'dash_so_detail'"
        :columns_from_parent="[
            {
              label: 'Part',
              field: 'part_number',
              type: 'text',
            },
            {
              label: 'Description',
              field: 'description',
              type: 'text',
            },
            {
              label: 'Entry Date',
              field: 'entry_date',
              type: 'text',
            },
            {
              label: 'Next Ship Date',
              field: 'next_ship_date',
              type: 'text',
            },
            {
              label: 'So Number',
              field: 'so_number',
              type: 'number',
            },
            {
              label: 'Est Cost',
              field: 'est_cost',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
            },
            {
              label: 'Qty Ordered',
              field: 'qty_ordered',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('0,0,0,0,0')},
            },
            {
              label: 'Bill Name',
              field: 'bill_name',
              type: 'text',
            },
            {
              label: 'Reference',
              field: 'reference',
              type: 'text',
            },
            {
              label: 'Unit Price',
              field: 'unit_price',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
            },
            {
              label: 'Vendor',
              field: 'vendor_name',
              type: 'text',
            },
            {
              label: 'PO Number',
              field: 'po_number',
              type: 'text',
            },
            {
              label: 'Dept Name',
              field: 'dept_name',
              type: 'text',
            },
            {
              label: 'Qty Bo',
              field: 'qty_bo',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('0,0,0,0,0')},
            },
            {
              label: 'Qty Rec',
              field: 'qty_rec',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('0,0,0,0,0')},
            },
            {
              label: 'PO Qty Ord',
              field: 'po_qty_ord',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('0,0,0,0,0')},
            },
            {
              label: 'Next Delivery',
              field: 'next_delivery_date',
              type: 'text',
            },
            {
              label: 'Total Price',
              field: 'total_price',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
            },
            {
              label: 'Total Cost',
              field: 'total_cost',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
            },
            {
              label: 'Profit',
              field: 'profit',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
            },
            {
              label: 'Margin',
              field: 'margin',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('0,0,0,0,0.00%')},
            },
            {
              label: 'Time Created',
              field: 'time_created',
              type: 'text',
              formatFn: function(value) {return value.split('T')[0]},
            },
          ]"
      />
      <div class="buttons is-right">
        <button class="button is-info"
          style="margin: 0.5em 0 0 0"
          @click="$emit('download-csv', [queryDataRaw.so.data, 'SO_Dashboard', null])">
          Download CSV
        </button>
      </div>
    </section>

    <section id="dashboard_data_po" v-if="Object.prototype.hasOwnProperty.call(queryDataRaw, 'po')">
      <DataTable2 
        
        :raw_data="queryDataRaw.po"
        :name="'dash_po_detail'"
        :columns_from_parent="[
            {
              label: 'Part',
              field: 'part_number',
              type: 'text',
            },
            {
              label: 'Description',
              field: 'description',
              type: 'text',
            },
            {
              label: 'Entry Date',
              field: 'entry_date',
              type: 'text',
            },
            {
              label: 'Next Delivery',
              field: 'next_delivery_date',
              type: 'text',
            },

            {
              label: 'Unit Cost',
              field: 'unit_cost',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
            },
            {
              label: 'Total Cost',
              field: 'total_cost',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('$0,0,0,0,0.00')},
            },
            {
              label: 'Qty Ordered',
              field: 'qty_ordered',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('0,0,0,0,0')},
            },
            {
              label: 'Qty Backorder',
              field: 'qty_backorder',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('0,0,0,0,0')},
            },
            {
              label: 'Vendor',
              field: 'vendor_name',
              type: 'text',
            },
            {
              label: 'PO Number',
              field: 'po_number',
              type: 'text',
            },
            {
              label: 'Dept Name',
              field: 'dept_name',
              type: 'text',
            },
            
            {
              label: 'Poso Qty',
              field: 'poso_qty',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('0,0,0,0,0')},
            },
            {
              label: 'Poso Qty Rec',
              field: 'poso_qty_rec',
              type: 'number',
              formatFn: function(value) {return numeral(value).format('0,0,0,0,0')},
            },
            {
              label: 'Time Created',
              field: 'time_created',
              type: 'text',
              formatFn: function(value) {return value.split('T')[0]},
            },
          ]"
      />
      <div class="buttons is-right">
        <button class="button is-info"
          style="margin: 0.5em 0 0 0"
          @click="$emit('download-csv', [queryDataRaw.po.data, 'PO_Dashboard', null])">
          Download CSV
        </button>
      </div>
    </section>
  </div>
</template>


<script>
import DataTable2 from '@/components/shared/DataTable2.vue';
import PlotlyFigure from '@/components/shared/Plotly.vue';
import moment from 'moment';
import VueDatePicker from '@vuepic/vue-datepicker';
import { getDates } from '@/helpers/dates.js'
import { DASHBOARD_SOPO, DASHBOARD_SOPO_DETAIL } from '@/data/url';
import HeroContainer from '@/components/shared/HeroContainer.vue';

export default {
  name: 'DashboardPoSo',
  components: {
    DataTable2,
    PlotlyFigure,
    VueDatePicker,
    HeroContainer,
  },
  computed:{
    plotData(){
      let data = [{type:'scatter', name:'Purchase', x:[], y:[], line: {shape: 'spline'},}, 
                  {type:'scatter',  name:'Sales', x:[], y:[], line: {shape: 'spline'},},
                  {type:'scatter', name:'PO Count', yaxis: 'y2', x:[], y:[], line: {shape: 'spline'},}, 
                  {type:'scatter',  name:'SO Count', yaxis: 'y2', x:[], y:[], line: {shape: 'spline'},},
                ]
      let pltdata = this.plotDataRaw

      if (Object.prototype.hasOwnProperty.call(pltdata, 'so') && Object.prototype.hasOwnProperty.call(pltdata, 'po') && Object.prototype.hasOwnProperty.call(pltdata, 'po_dollars') && Object.prototype.hasOwnProperty.call(pltdata, 'so_dollars')) {
        let so_count = pltdata.so
        let po_count = pltdata.po
        let so_dollars = pltdata.so_dollars
        let po_dollars = pltdata.po_dollars
        for(let poc of po_count){
            data[2].x.push(poc.period)
            data[2].y.push(poc.count)
        }
        for(let soc of so_count){
            data[3].x.push(soc.period)
            data[3].y.push(soc.count)
        }
        for(let pod of po_dollars){
            data[0].x.push(pod.period)
            data[0].y.push(pod.dollars)
        }
        for(let sod of so_dollars){
            data[1].x.push(sod.period)
            data[1].y.push(sod.dollars)
        }
      }
      return data
    },
  },
  data: function(){
    return {
      queryDataRaw: [],
      plotDataRaw: [],
      numeral: require('numeral'),
      figureKey: 0,
      period: 'week',
      period_last_filtered: 'week',
      date_range: 'this_quarter',
      range: [
        moment().startOf('quarter').toDate(),
        moment().endOf('quarter').toDate()
      ],
      layout: {
        legend: {
          x: 0,
          y: 1.3
        },
        yaxis: {
          title: {
                  text: 'Open Orders: Dollars',
                  font: {
                    size: 18,
                  }
                },
          rangemode: 'tozero',
          },
        yaxis2: {
          title: {
                  text: 'Open Orders: Count',
                  font: {
                    size: 18,
                  }
                },
          rangemode: 'tozero',
          overlaying: 'y',
          side: 'right'
        }
      },
      options : {
        displayModeBar: false,
        responsive: true
      },
    };
  },
  mounted: function(){
    this.ajax_get_dashboard()
  },
  watch: {
    plotData:
      function(){
        // Change key to force the component to re-render
        // otherwise it will have height=0
        this.figureKey += 1
      }
  },
  methods: {
    getDates,
    plot_click(click_data){
      let date = click_data.points[0].x
      let period =  this.period_last_filtered

      let dt = moment.utc(date)
      let dt2 = moment.utc(dt).endOf(period)
      this.ajax_get_detail(dt.toISOString(), dt2.toISOString())
    },
    reset(){
      this.plotDataRaw = []
      this.queryDataRaw = []
      this.period = 'week'
      this.period_last_filtered = 'week',
      this.date_range=  'this_quarter'
      this.range = [
        moment().startOf('quarter').toDate(),
        moment().endOf('quarter').toDate()
      ]
    },
    change_date(date_range){
      let range = this.getDates(date_range)
      if(range){
        this.range = range
      }
    },
    set_searching(is_searching){
      this.searchStore.set_ajax_searching(is_searching)
    },
    filter_records(){
      this.ajax_get_dashboard(this.filter_customer, this.filter_user)
    },
    ajax_get_dashboard(){
      this.plotDataRaw = []
      this.queryDataRaw = []
      this.period_last_filtered = this.period
      let url = DASHBOARD_SOPO
      let begin_date = moment.utc(this.range[0]).format('YYYY-MM-DD')
      let end_date = moment.utc(this.range[1]).add(1,'day').format('YYYY-MM-DD')
      this.set_searching(true)
      let this_vue = this
      function set_dash(this_vue, data){
        this_vue.plotDataRaw = data
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({begin_date: begin_date, end_date: end_date, period: this.period, }),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_dash(this_vue, res.data)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
    ajax_get_detail(begin_date, end_date){
      this.queryDataRaw = []
      let url = DASHBOARD_SOPO_DETAIL
      this.set_searching(true)
      let this_vue = this
      function set_detail(this_vue, data){
        this_vue.queryDataRaw = data
      }
      fetch(url, {
        method:'POST',
        body: JSON.stringify({begin_date: begin_date, end_date: end_date, }),
      })
      .then(res => res.json())
      .then(res => {
        this_vue.set_searching(false)
        if (res.success){
          set_detail(this_vue, res.data)
        }
      })
      .catch(e => {
        this_vue.set_searching(false)
        console.error(JSON.stringify(e.message));
      });
    },
  }
};

</script>
